module.exports = {
  siteTitle: "Amila Surendra", // <title>
  shortSiteTitle: "Amila Surendra", // <title> ending for posts and pages
  siteDescription: "Amila Surendra",
  siteUrl: "http://blog.amilasurendra.com",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "Amila Surendra",
  authorTwitterAccount: "",
  authorGithub: "https://github.com/amilasurendra",
  authorLinkedin: "https://lk.linkedin.com/in/amilasurendra",

  /* header text */
  headerTitle: "Amila Surendra",
  headerSubTitle: "",

  /* manifest.json */
  manifestName: "Amila Surendra",
  manifestShortName: "amilasu", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",
};
